var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class CacheUtils {
  static async getOrSetCache(key, fetchData) {
    if (this.cache.has(key)) {
      return this.cache.get(key);
    }
    const promise = fetchData();
    this.cache.set(key, promise);
    return promise;
  }
}
__publicField(CacheUtils, "cache", /* @__PURE__ */ new Map());

export { CacheUtils };
